import React, { useState, useEffect, useMemo } from "react";
import {
  Button,
  Form,
  InputGroup,
  Table,
  OverlayTrigger,
  Image,
} from "react-bootstrap";
import { MdAdd, MdSearch, MdUpload } from "react-icons/md";
import { sleevesAPI } from "../services/api";
import CustomPagination from "../components/comman/CustomPagination";
import SleeveModal from "../components/modals/sleeve/SleeveModal";
import DeleteModal from "../components/modals/delete-modal/DeleteModal";
import CustomAction from "../components/comman/CustomAction";
import { showToast } from "../services/toast";
import ImageModal from "../components/modals/image-preview/ImageModal";
import ImportModal from "../components/modals/sleeve/ImportModal";
import { DEFAULT_PAGE_OPTIONS } from "../utils/constants";
import SimpleTable from "../components/comman/custom-table/SimpleTable";

const Sleeves = () => {
  const [sleeves, setSleeves] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageModal, setImageModal] = useState({
    open: false,
    image: "",
    alt: "",
  });
  // const [showModal, setShowModal] = useState(false);

  // const [editing, setEditing] = useState(null);
  // const [form, setForm] = useState({
  //   partnerCode: "",
  //   name: "",
  //   companyName: "",
  //   email: "",
  //   mobileNumber: "",
  //   website: "",
  //   arnAfmiNo: "",
  // });

  const [showImport, setShowImport] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  // const [currentPage, setCurrentPage] = useState(1);
  // const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const [importReport, setImportReport] = useState(null);
  const [importSuccess, setImportSuccess] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [sleeveToDelete, setSleeveToDelete] = useState(null);

  const [importing, setImporting] = useState(false);

  const [form, setForm] = useState({
    sleeve_type: "",
    sleeve_name: "",
    file: null,
    variable: "",
    sleeve_width: "",
    sleeve_height: "",
    print_page_width: "",
    print_page_height: "",
    orientation: "",
    print_type: "",
    qty_in_page: "",
  });

  const ORIENTATIONS = ["Portrait", "Landscape"];
  const PRINT_TYPES = ["One Side", "Front back"];

  const [errors, setErrors] = useState({});

  const isPositiveNumber = (v) =>
    v !== "" && v !== null && v !== undefined && !isNaN(v) && Number(v) > 0;
  const isPositiveInteger = (v) => isPositiveNumber(v) && Number(v) % 1 === 0;

  const validateForm = (isEditing) => {
    const e = {};

    // Required always
    if (!String(form.sleeve_type || "").trim())
      e.sleeve_type = "Sleeve type is required.";
    if (!String(form.sleeve_name || "").trim())
      e.sleeve_name = "Sleeve name is required.";

    if (!isEditing) {
      // Numbers > 0
      if (!isPositiveNumber(form.sleeve_width))
        e.sleeve_width = "Sleeve width must be a positive number.";
      if (!isPositiveNumber(form.sleeve_height))
        e.sleeve_height = "Sleeve height must be a positive number.";
      if (!isPositiveNumber(form.print_page_width))
        e.print_page_width = "Page width must be a positive number.";
      if (!isPositiveNumber(form.print_page_height))
        e.print_page_height = "Page height must be a positive number.";
      if (!isPositiveInteger(form.qty_in_page))
        e.qty_in_page = "Qty in page must be a positive whole number.";

      // Enums
      if (!ORIENTATIONS.includes(form.orientation))
        e.orientation = "Select a valid orientation.";
      if (!PRINT_TYPES.includes(form.print_type))
        e.print_type = "Select a valid print type.";
    }

    return e;
  };

  const DEFAULT_COORDS = {};
  const DEFAULT_SIZES = {};
  const [varCoords, setVarCoords] = useState(DEFAULT_COORDS);
  const [varSizes, setVarSizes] = useState(DEFAULT_SIZES);

  // const getVarMap = (s) =>
  //   s.variable_positions || s.variables || s.variable_map || s.coords || {};


  const prefillVariablesFromRecord = (s) => {
    const positions = s.variable_positions || {};
    setVarCoords({
      ...DEFAULT_COORDS,
      ...positions,
    });

    setVarSizes({
      ...DEFAULT_SIZES,
      logo_size: positions.logo_size || DEFAULT_SIZES.logo_size,
      partner_box: positions.partner_box || DEFAULT_SIZES.partner_box,
    });
  };

  const buildVariablesObject = () => {
    return {
      ...varCoords,
      ...varSizes,
    };
  };
  useEffect(() => {
    const id = setTimeout(() => setDebouncedSearch(searchTerm.trim()), 300);
    return () => clearTimeout(id);
  }, [searchTerm]);

  const fetchSleeves = async (opts = {}) => {
    setLoading(true);
    try {
      const res = await sleevesAPI.getSleeves({
        page: opts.page ?? currentPage,
        limit: opts.limit ?? pageSize,
        search: opts.search ?? debouncedSearch,
      });

      if (res?.isSuccess) {
        // normalize list key
        const list =
          res.data?.sleeveMasters ??
          res.data?.sleeves ??
          res.data?.Sleeves ??
          [];

        const pg = res.data?.pagination ?? {
          total: list.length,
          page: 1,
          limit: pageSize,
          totalPages: 1,
        };

        setSleeves(list);
        setTotal(pg.total || 0);
        setTotalPages(pg.totalPages || 1);

        // sync with server echo/clamp if needed
        if (pg.page && pg.page !== currentPage) setCurrentPage(pg.page);
        if (pg.limit && pg.limit !== pageSize) setPageSize(pg.limit);
      } else {
        // toast.error(res?.message || "Failed to load sleeves");
        showToast("error", res?.message || "Failed to load sleeves");
      }
    } catch (e) {
      showToast(
        "error",
        e?.response?.data?.message || "Failed to load sleeves"
      );
    } finally {
      setLoading(false);
    }
  };

  // initial + on page/size/search changes
  useEffect(() => {
    fetchSleeves({
      page: currentPage,
      limit: pageSize,
      search: debouncedSearch,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, debouncedSearch]);

  // const onImport = async (e) => {
  //   const file = e.target.files?.[0];
  //   if (!file) return;
  //   try {
  //     const res = await sleevesAPI.importSleeves(file);
  //     if (res.isSuccess) {
  //       toast.success("Partners imported");
  //       setShowImport(false);
  //       fetchSleeves();
  //     } else {
  //       toast.error(res.message || "Import failed");
  //     }
  //   } catch (err) {
  //     toast.error(err.response?.data?.message || "Import failed");
  //   }
  // };

  const onImport = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setImporting(true);
    setImportReport(null);
    setImportSuccess(null);
    try {
      const res = await sleevesAPI.importSleeves(file);

      if (res?.isSuccess) {
        const hasErrors = !!res?.data?.errors?.length;
        // const hasUpserts =
        //   (res?.data?.createdCount ?? 0) + (res?.data?.updatedCount ?? 0) > 0;

        if (hasErrors) {
          setImportReport(res?.data);
          setImportSuccess(false); // imported with validation errors
          setShowImport(true);
          showToast("error", "Import completed with validation errors");
        } else {
          // toast.success("Sleeves imported successfully");
          showToast("success", "Sleeves imported successfully");
          setImportReport(null);
          setImportSuccess(null);
          setShowImport(false);
          fetchSleeves();
        }
      } else {
        // Non-success flag from API
        setImportReport(res?.data || null);
        setImportSuccess(false);
        setShowImport(true);
        // toast.error(res?.message || "Import failed");
        showToast("error", res?.message || "Import failed");
      }
    } catch (err) {
      const data = err?.response?.data?.data;
      const message = err?.response?.data?.message || "Import failed!";
      showToast("error", message);

      if (data && data !== 0) {
        setImportReport(data); // expected same shape: { totalRows, errors: [], ... }
        setImportSuccess(false);
        setShowImport(true);
      } else {
        setImportReport(null);
        setImportSuccess(null);
        setShowImport(false);
      }
    } finally {
      setImporting(false);
      // reset the input so user can re-upload same file if needed
      e.target.value = "";
    }
  };

  // const startIndex = total === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  // const endIndex = total === 0 ? 0 : Math.min(currentPage * pageSize, total);

  // // compact page window
  // const pageItems = useMemo(() => {
  //   const items = [];
  //   const maxButtons = 7;
  //   const add = (n) =>
  //     items.push(
  //       <Pagination.Item
  //         key={n}
  //         active={n === currentPage}
  //         onClick={() => setCurrentPage(n)}
  //       >
  //         {n}
  //       </Pagination.Item>
  //     );

  //   if (totalPages <= maxButtons) {
  //     for (let i = 1; i <= totalPages; i++) add(i);
  //     return items;
  //   }

  //   const windowSize = 3;
  //   const left = Math.max(2, currentPage - windowSize);
  //   const right = Math.min(totalPages - 1, currentPage + windowSize);

  //   add(1);
  //   if (left > 2) items.push(<Pagination.Ellipsis key="l-ell" disabled />);
  //   for (let i = left; i <= right; i++) add(i);
  //   if (right < totalPages - 1)
  //     items.push(<Pagination.Ellipsis key="r-ell" disabled />);
  //   add(totalPages);

  //   return items;
  // }, [currentPage, totalPages]);

  const downloadValidationErrorsCsv = (report) => {
    if (!report?.errors?.length) return;

    const dataKeys = Array.from(
      report.errors.reduce((set, r) => {
        Object.keys(r.data || {}).forEach((k) => set.add(k));
        return set;
      }, new Set())
    );

    const header = ["row", "errors", ...dataKeys].join(",");
    const lines = report.errors.map((r) => {
      const errMsg = (r.errors || []).join("; ");
      const cells = dataKeys.map((k) => {
        let v = r.data?.[k];
        if (v === null || v === undefined) v = "";
        v = String(v).replace(/"/g, '""');
        return `"${v}"`;
      });
      return [`"${r.row}"`, `"${errMsg.replace(/"/g, '""')}"`, ...cells].join(
        ","
      );
    });

    const csv = [header, ...lines].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `sleeve-import-validation-errors-${Date.now()}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const startCreate = () => {
    setEditing(null);
    setForm({
      sleeve_type: "",
      sleeve_name: "",
      sleeve_width: "",
      sleeve_height: "",
      print_page_width: "",
      print_page_height: "",
      orientation: "",
      print_type: "",
      qty_in_page: "",
    });
    setVarCoords(DEFAULT_COORDS);
    setVarSizes(DEFAULT_SIZES);
    setErrors({});
    setShowModal(true);
  };

  const startEdit = (s) => {
    setEditing(s);
    console.log("Edit start hua:", s);

    setForm({
      sleeve_type: s.sleeve_type || "",
      sleeve_name: s.sleeve_name || "",
      sleeve_width:
        pick(s.sleeve_width, s.width, s.sleeve_width_cm, s.sleeveWidth) || "",
      sleeve_height:
        pick(s.sleeve_height, s.height, s.sleeve_height_cm, s.sleeveHeight) ||
        "",
      print_page_width:
        pick(s.page_width, s.print_page_width, s.pageWidth) || "",
      print_page_height:
        pick(s.page_height, s.print_page_height, s.pageHeight) || "",
      orientation: pick(s.orientation, s.page_orientation) || "",
      print_type: pick(s.print_type, s.printType) || "",
      qty_in_page: s.qty_in_page ?? s.qty ?? "",
    });

    // variables prefill
    prefillVariablesFromRecord(s);

    setErrors({});
    setShowModal(true);
  };

  //  const saveSleeve = async (e) => {
  //   e.preventDefault();
  //   console.log("Submitting JSON payload:", form);

  //   try {
  //     if (editing) {
  //       await sleevesAPI.updateSleeve(editing.id, form);
  //       toast.success("Sleeve updated");
  //     } else {
  //       await sleevesAPI.createSleeve(form);
  //       toast.success("Sleeve created");
  //     }
  //     setShowModal(false);
  //     fetchSleeves();
  //   } catch (err) {
  //     console.error("Save sleeve error (JSON):", err.response?.data);
  //     toast.error(err.response?.data?.message || "Save failed");
  //   }
  // };

  // const toNum = (v) =>
  //   v === "" || v === null || v === undefined ? undefined : Number(v);

  const buildLegacyArrays = () => {
    return {
      variable_coordinates: Object.keys(varCoords).map((k) => ({
        key: k,
        ...varCoords[k],
      })),
      variable_sizes: Object.keys(varSizes).map((k) => ({
        key: k,
        ...varSizes[k],
      })),
    };
  };

  const handleCloseSleeveModal = () => {
    setShowModal(false);
    setErrors({});
  };

  const saveSleeve = async (e) => {
    e.preventDefault();

    const vErrors = validateForm();
    if (Object.keys(vErrors).length) {
      setErrors(vErrors);
      setTimeout(() => {
        const first = document.querySelector(".is-invalid");
        if (first) first.focus();
      }, 0);
      showToast("error", "Please fix the highlighted errors.");
      return;
    }

    try {
      const variables = buildVariablesObject();
      const { variable_coordinates, variable_sizes } = buildLegacyArrays();

      let payload = {
        sleeve_name: form.sleeve_name,
        sleeve_type: form.sleeve_type,
        sleeve_width: form.sleeve_width,
        sleeve_height: form.sleeve_height,
        page_width: form.print_page_width,
        page_height: form.print_page_height,
        orientation: form.orientation,
        print_type: form.print_type,
        qty_in_page: form.qty_in_page,
        variable_positions: variables,
        variable_coordinates,
        variable_sizes,
      };

      if (editing) {
        await sleevesAPI.updateSleeve(editing.id, payload);
        console.log("Payload ::: ", payload);
        showToast("success", "Sleeve updated");
      } else {
        console.log("Payload ::: ", payload);
        await sleevesAPI.createSleeve(payload);
        showToast("success", "Sleeve created");
      }

      setErrors({});
      setShowModal(false);
      fetchSleeves();
    } catch (err) {
      console.error("Save sleeve error:", err);
      showToast("error", err?.response?.data?.message || "Save failed");
    }
  };

  const removeSleeve = async () => {
    if (!sleeveToDelete) return;
    try {
      await sleevesAPI.deleteSleeve(sleeveToDelete.id);
      // toast.success("Sleeve deleted");
      showToast("success", "Sleeve deleted");
      fetchSleeves();
    } catch (err) {
      // toast.error("Delete failed");
      showToast("error", err?.response?.data?.message || "Delete failed");
    } finally {
      setShowDeleteModal(false);
      setSleeveToDelete(null);
    }
  };

  //--------------------------------------------------------------
  // Collect one or many file paths regardless of backend shape
  const getFilesFromAnyShape = (raw) => {
    if (!raw) return [];
    if (typeof raw === "string") return [raw].filter(Boolean);
    if (Array.isArray(raw)) return raw.filter(Boolean);

    if (typeof raw === "object") {
      // Prefer keys like file, file_1, file_2 ... in numeric order
      const ordered = Object.entries(raw)
        .filter(([k, v]) => v && /^file(_\d+)?$/i.test(k))
        .sort(([a], [b]) => {
          const na = parseInt(a.split("_")[1] ?? "1", 10);
          const nb = parseInt(b.split("_")[1] ?? "1", 10);
          return (isNaN(na) ? 1 : na) - (isNaN(nb) ? 1 : nb);
        })
        .map(([, v]) => v);

      const flattened = ordered.flatMap((v) =>
        Array.isArray(v) ? v.filter(Boolean) : [v]
      );

      // Fallback: if no canonical keys matched, take any string-ish values
      const fallback =
        flattened.length === 0
          ? Object.values(raw).flatMap((v) =>
              Array.isArray(v)
                ? v.filter(Boolean)
                : typeof v === "string"
                ? [v]
                : []
            )
          : [];

      // Dedupe while preserving order
      const seen = new Set();
      const out = [];
      [...flattened, ...fallback].forEach((p) => {
        if (p && !seen.has(p)) {
          seen.add(p);
          out.push(p);
        }
      });
      return out;
    }

    return [];
  };

  // Wrapper that tries multiple fields your BE has used historically
  const getSleeveFilePaths = (sleeve) => {
    const raw =
      // historical single fields
      sleeve.file_path ??
      sleeve.file ??
      sleeve.file_url ??
      sleeve.path ??
      sleeve.filePath ??
      // possible plural/map fields
      sleeve.files ??
      sleeve.file_map ??
      sleeve.fileMap ??
      sleeve.file_obj ??
      sleeve.fileObj;

    return getFilesFromAnyShape(raw);
  };

  //--------------------------------------------------------------

  const pick = (...vals) =>
    vals.find((v) => v !== undefined && v !== null && v !== "");
  const formatDim = (w, h, unit) => {
    if (w == null || h == null || w === "" || h === "") return "—";
    const u = unit ? ` ${unit}` : "";
    return `${w} × ${h}${u}`;
  };
  const kindFromPath = (p = "") =>
    /\.(png|jpe?g|webp|gif)$/i.test(p) || /_(img)$/i.test(p)
      ? "image"
      : /\.(pdf)$/i.test(p)
      ? "pdf"
      : "other";
  const buildFileUrl = (p = "") => {
    // If backend returns '/uploads/..' or 'uploads/..', make it absolute with your API base
    // Set VITE_API_BASE_URL in your env like: https://api.yourdomain.com
    if (!p) return "";
    if (/^https?:\/\//i.test(p)) return p;
    const base = process.env?.REACT_APP_API_URL || "";
    const clean = p.replace(/^\/+/, ""); // remove leading slashes
    return base ? `${base}/${clean}` : `/${clean}`;
  };

  const has = (o, k) => o && Object.prototype.hasOwnProperty.call(o, k);
  const fmt = (n) => (typeof n === "number" ? Number(n.toFixed(2)) : n);

  const summarizeVar = (key, val) => {
    // size-only node (e.g. logo_size)
    if (has(val, "width") || has(val, "height")) {
      const w = has(val, "width") ? fmt(val.width) : "—";
      const h = has(val, "height") ? fmt(val.height) : "—";
      return `${key}: ${w}×${h}`;
    }

    // coordinate node (x,y + optional attributes)
    const parts = [];
    const x = has(val, "x") ? fmt(val.x) : "—";
    const y = has(val, "y") ? fmt(val.y) : "—";
    parts.push(`${key}: ${x}×${y}`);

    if (has(val, "fontSize")) parts.push(`fs=${fmt(val.fontSize)}`);
    if (has(val, "font_style") || has(val, "fontStyle")) {
      parts.push(`${val.font_style || val.fontStyle}`);
    }
    if (has(val, "rotate") || has(val, "rotation")) {
      parts.push(`rot=${fmt(val.rotate ?? val.rotation)}°`);
    }
    if (has(val, "fontWeight")) parts.push(`fw=${val.fontWeight}`);
    if (has(val, "color")) parts.push(`color=${val.color}`);

    return parts.join(", ");
  };

  const toEntries = (obj) =>
    Object.entries(obj || {}).map(([k, v]) => ({ key: k, val: v }));
  const columns = useMemo(() => {
    return [
      // Type
      {
        id: "type",
        header: "Type",
        accessor: "sleeve_type",
        minWidth: 120,
        sortType: "text",
      },

      // Name
      {
        id: "name",
        header: "Name",
        accessor: "sleeve_name",
        minWidth: 200,
        className: "text-truncate",
        sortType: "text",
        cell: (v) => <span title={v}>{v ?? "—"}</span>,
      },

      // Sleeve (W×H)
      {
        id: "sleeve_dim",
        header: "Sleeve (W×H)",
        minWidth: 120,
        sortType: (a, b) => {
          // sort by area if available, else width
          const [aw, ah] = [
            pick(a?.sleeve_width, a?.width, a?.sleeve_width_cm, a?.sleeveWidth),
            pick(
              a?.sleeve_height,
              a?.height,
              a?.sleeve_height_cm,
              a?.sleeveHeight
            ),
          ];
          const [bw, bh] = [
            pick(b?.sleeve_width, b?.width, b?.sleeve_width_cm, b?.sleeveWidth),
            pick(
              b?.sleeve_height,
              b?.height,
              b?.sleeve_height_cm,
              b?.sleeveHeight
            ),
          ];
          const aa = Number(aw) * Number(ah);
          const bb = Number(bw) * Number(bh);
          if (isNaN(aa) && isNaN(bb)) return 0;
          if (isNaN(aa)) return -1;
          if (isNaN(bb)) return 1;
          return aa - bb;
        },
        cell: (_v, s) =>
          formatDim(
            pick(s.sleeve_width, s.width, s.sleeve_width_cm, s.sleeveWidth),
            pick(s.sleeve_height, s.height, s.sleeve_height_cm, s.sleeveHeight),
            pick(s.sleeve_unit, s.sleeve_size_unit, s.size_unit, s.unit)
          ),
      },

      // Page (W×H)
      {
        id: "page_dim",
        header: "Page (W×H)",
        minWidth: 120,
        sortType: (a, b) => {
          const [aw, ah] = [
            pick(a.page_width, a.print_page_width, a.pageWidth),
            pick(a.page_height, a.print_page_height, a.pageHeight),
          ];
          const [bw, bh] = [
            pick(b.page_width, b.print_page_width, b.pageWidth),
            pick(b.page_height, b.print_page_height, b.pageHeight),
          ];
          const aa = Number(aw) * Number(ah);
          const bb = Number(bw) * Number(bh);
          if (isNaN(aa) && isNaN(bb)) return 0;
          if (isNaN(aa)) return -1;
          if (isNaN(bb)) return 1;
          return aa - bb;
        },
        cell: (_v, s) =>
          formatDim(
            pick(s.page_width, s.print_page_width, s.pageWidth),
            pick(s.page_height, s.print_page_height, s.pageHeight),
            pick(s.page_unit, s.print_page_unit)
          ),
      },

      // Orient.
      {
        id: "orientation",
        header: "Orient.",
        minWidth: 100,
        sortType: "text",
        cell: (_v, s) => pick(s.orientation, s.page_orientation) || "—",
        className: "text-capitalize",
      },

      // Print Type
      {
        id: "print_type",
        header: "Print Type",
        minWidth: 120,
        sortType: "text",
        cell: (_v, s) => pick(s.print_type, s.printType) || "—",
        className: "text-capitalize",
      },

      // File (thumbnail + “+n more” popover)
      {
        id: "file",
        header: "File",
        minWidth: 180,
        sortable: false,
        cell: (_v, s) => {
          const files = getSleeveFilePaths(s);
          if (!files.length) return <span className="text-muted">—</span>;

          const first = files[0];
          const url = buildFileUrl(first);
          const kind = kindFromPath(url);
          const moreCount = Math.max(0, files.length - 1);

          const opener =
            kind === "image" ? (
              // <a
              //   href={url}
              //   target="_blank"
              //   rel="noreferrer"
              //   className="d-inline-flex align-items-center text-decoration-none"
              //   title="Open file"
              // >
              //   <img src={url} alt="" width={28} height={28} className="rounded border" />
              //   <span className="ms-2 text-truncate" style={{ maxWidth: 100 }}>
              //     Open
              //   </span>
              // </a>
              <button
                className="border-none p-0 "
                onClick={() =>
                  setImageModal({ open: true, image: url, alt: "image" })
                }
              >
                <Image
                  src={url}
                  alt=""
                  width={28}
                  height={28}
                  className="rounded-2"
                />
              </button>
            ) : (
              <a
                href={url}
                target="_blank"
                rel="noreferrer"
                className="text-decoration-none"
                title="Open file"
              >
                {kind === "pdf" ? "Open PDF" : "Open File"}
              </a>
            );
          return (
            <div className="d-flex align-items-center gap-2">
              {opener}
              {moreCount > 0 && (
                <OverlayTrigger
                  trigger="click"
                  rootClose
                  placement="left"
                  overlay={
                    <div className="popover show" role="tooltip">
                      <h6
                        className="popover-header py-1 px-2 lh-sm"
                        style={{ fontSize: "14px" }}
                      >
                        All Files
                      </h6>
                      <div className="popover-body p-0">
                        <Table bordered responsive size="sm" className="mb-0">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Type</th>
                              <th>Open</th>
                            </tr>
                          </thead>
                          <tbody>
                            {files.map((fp, idx) => {
                              const furl = buildFileUrl(fp);
                              const fkind = kindFromPath(furl);
                              return (
                                <tr key={fp + idx}>
                                  <td>{idx + 1}</td>
                                  <td className="text-uppercase">{fkind}</td>
                                  <td>
                                    <Button
                                      variant="outline-primary"
                                      className="py-1 px-2 lh-sm"
                                      style={{ fontSize: "12px" }}
                                      onClick={() =>
                                        setImageModal({
                                          open: true,
                                          image: furl,
                                          alt: "image",
                                        })
                                      }
                                    >
                                      {fkind === "image"
                                        ? "Open Image"
                                        : fkind === "pdf"
                                        ? "Open PDF"
                                        : "Open File"}
                                    </Button>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  }
                >
                  <Button size="sm" variant="outline-primary">
                    +{moreCount} more
                  </Button>
                </OverlayTrigger>
              )}
            </div>
          );
        },
      },

      // Variables (compact summary + popover table)
      {
        id: "variables",
        header: "Variables",
        minWidth: 220,
        sortable: false,
        cell: (_v, s) => {
          const vmap =
            s.variables ||
            s.variable_map ||
            s.variable_positions ||
            s.coords ||
            null;

          if (!vmap || Object.keys(vmap).length === 0) {
            return <span className="text-muted">—</span>;
          }

          const entries = toEntries(vmap);
          const summary = entries
            .slice(0, 2)
            .map((e) => summarizeVar(e.key, e.val))
            .join(" • ");
          const moreCount = Math.max(0, entries.length - 2);

          return (
            <div className="d-flex align-items-center gap-2">
              <div
                className="small text-truncate"
                title={summary}
                style={{ maxWidth: 260 }}
              >
                {summary}
                {moreCount ? ` • +${moreCount} more` : ""}
              </div>

              <OverlayTrigger
                trigger="click"
                rootClose
                placement="left"
                overlay={
                  <div className="popover show" role="tooltip">
                    <h6
                      className="popover-header py-1 px-2 lh-sm"
                      style={{ fontSize: "14px" }}
                    >
                      Variables
                    </h6>
                    <div className="popover-body p-0">
                      <Table bordered responsive size="sm" className="mb-0">
                        <thead>
                          <tr>
                            <th style={{ whiteSpace: "nowrap" }}>Key</th>
                            <th>X</th>
                            <th>Y</th>
                            <th>W</th>
                            <th>H</th>
                            <th>Font</th>
                            <th>Style</th>
                            <th>Rotate</th>
                            <th>Print Side</th>
                            <th>Font Colour</th>
                            <th>Label Size</th>
                            <th>Label Style</th>
                            <th> Label Colour</th>
                          </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                          {entries.map(({ key, val }) => {
                            const x = has(val, "x") ? fmt(val.x) : "—";
                            const y = has(val, "y") ? fmt(val.y) : "—";
                            const w = has(val, "width") ? fmt(val.width) : "—";
                            const h = has(val, "height")
                              ? fmt(val.height)
                              : "—";
                            const font =
                              has(val, "font_size") || has(val, "fontSize")
                                ? fmt(val.font_size ?? val.fontSize)
                                : "—";
                            const style =
                              val?.font_style ?? val?.fontStyle ?? "—";
                            const rot =
                              has(val, "rotate") ||
                              has(val, "rotation") ||
                              has(val, "font_type")
                                ? fmt(
                                    val.font_type ?? val.rotate ?? val.rotation
                                  )
                                : "—";
                            const print_side = has(val, "print_side")
                              ? fmt(val.print_side)
                              : "—";
                            const font_colour = has(val, "font_colour")
                              ? fmt(val.font_colour)
                              : "—";
                            const label_font_size = has(val, "label_font_size")
                              ? fmt(val.label_font_size)
                              : "—";
                            const label_font_style = has(
                              val,
                              "label_font_style"
                            )
                              ? fmt(val.label_font_style)
                              : "—";
                            const label_font_colour = has(
                              val,
                              "label_font_colour"
                            )
                              ? fmt(val.label_font_colour)
                              : "—";

                            return (
                              <tr key={key}>
                                <td className="text-nowrap">{key}</td>
                                <td>{x}</td>
                                <td>{y}</td>
                                <td>{w}</td>
                                <td>{h}</td>
                                <td>{font}</td>
                                <td className="text-capitalize text-nowrap">
                                  {style}
                                </td>
                                <td>{rot === "—" ? "—" : `${rot}°`}</td>
                                <td>{print_side}</td>
                                <td>{font_colour}</td>
                                <td>{label_font_size}</td>
                                <td className="text-capitalize text-nowrap">
                                  {label_font_style}
                                </td>
                                <td>{label_font_colour}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                }
              >
                <Button size="sm" variant="outline-primary">
                  View
                </Button>
              </OverlayTrigger>
            </div>
          );
        },
      },

      {
        id: "created_at",
        header: "Created At",
        accessor: "created_at", // change to "createdAt" if your API uses camelCase
        minWidth: 160,
        sortType: "date",
        cell: (v, row) => {
          // fallback if API returns createdAt instead of created_at
          const raw = v ?? row?.created_at;
          if (!raw) return "—";
          const dt = new Date(raw);
          if (isNaN(+dt)) return "—";

          const dateStr = dt.toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
          const timeStr = dt.toLocaleString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });

          return (
            <div className="d-flex flex-column lh-sm gap-1">
              <strong>{dateStr}</strong>
              <p className="m-0">{timeStr}</p>
            </div>
          );
        },
      },

      // Actions
      // {
      //   id: "actions",
      //   header: "Actions",
      //   minWidth: 120,
      //   sortable: false,
      //   cell: (_v, s) => (
      //     <div className="d-flex align-items-center">
      //       <Button
      //         size="sm"
      //         className="table-btn me-2 edit-btn"
      //         onClick={() => startEdit(s)}
      //         title="Edit"
      //       >
      //         <MdEdit />
      //       </Button>
      //       <Button
      //         size="sm"
      //         className="table-btn delete-btn"
      //         onClick={() => {
      //           setSleeveToDelete(s);
      //           setShowDeleteModal(true);
      //         }}
      //         title="Delete"
      //       >
      //         <MdDelete />
      //       </Button>
      //     </div>
      //   ),
      // },
      {
        id: "actions",
        header: "Actions",
        minWidth: 72,
        className: "text-end",
        isActions: true,
      },
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="h-100 overflow-auto position-relative z-1">
        <div className="d-flex justify-content-between align-items-center mb-1 p-3 sticky-top bg-body">
          <h4 className="mb-0">Sleeve Module</h4>
          <div className="d-flex align-items-end gap-2">
            <InputGroup className="search-bar border-primary rounded-2">
              <Form.Control
                placeholder="Search sleeves..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <InputGroup.Text>
                <MdSearch />
              </InputGroup.Text>
            </InputGroup>
            <CustomAction
              actions={[
                {
                  label: "Import Excel",
                  icon: MdUpload,
                  onClick: () => setShowImport(true),
                },
                {
                  label: "Add Sleeve",
                  icon: MdAdd,
                  onClick: startCreate,
                },
              ]}
            />
          </div>
        </div>
        <div className="content-cover px-3 position-relative">
          {/* <div className="table-cover">
            {loading ? (
              <div className="text-center py-3">
                <Spinner animation="border" />
              </div>
            ) : (
              <>
                <Table hover bordered className="position-relative z-1 mb-0">
                  <thead className="sticky-top">
                    <tr>
                      
                      <th>Type</th>
                      <th>Name</th>
                      <th>Sleeve (W×H)</th>
                      <th>Page (W×H)</th>
                      <th>Orient.</th>
                      <th>Print Type</th>
                      <th>File</th>
                      <th>Variables</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sleeves.map((s) => (
                      <tr key={s.id}>
                        
                        <td>{s.sleeve_type}</td>
                        <td className="text-truncate" style={{ maxWidth: 220 }}>
                          {s.sleeve_name}
                        </td>

                        
                        <td className="text-nowrap">
                          {formatDim(
                            pick(
                              s.sleeve_width,
                              s.width,
                              s.sleeve_width_cm,
                              s.sleeveWidth
                            ),
                            pick(
                              s.sleeve_height,
                              s.height,
                              s.sleeve_height_cm,
                              s.sleeveHeight
                            ),
                            pick(
                              s.sleeve_unit,
                              s.sleeve_size_unit,
                              s.size_unit,
                              s.unit
                            ) // optional
                          )}
                        </td>

                        
                        <td className="text-nowrap">
                          {formatDim(
                            pick(s.page_width, s.print_page_width, s.pageWidth),
                            pick(
                              s.page_height,
                              s.print_page_height,
                              s.pageHeight
                            ),
                            pick(s.page_unit, s.print_page_unit) // optional
                          )}
                        </td>

                        
                        <td className="text-capitalize">
                          {pick(s.orientation, s.page_orientation) || "—"}
                        </td>
                        <td className="text-capitalize">
                          {pick(s.print_type, s.printType) || "—"}
                        </td>

                        
                         <td style={{ minWidth: 140 }}>
                        {(() => {
                          const rawPath = pick(
                            s.file_path,
                            s.file,
                            s.file_url,
                            s.path,
                            s.filePath
                          );
                          if (!rawPath)
                            return <span className="text-muted">—</span>;
                          const url = buildFileUrl(rawPath);
                          const kind = kindFromPath(url);

                          return (
                            <div className="d-flex align-items-center gap-2">
                              {kind === "image" ? (
                                <OverlayTrigger
                                  overlay={<BsTooltip>Open file</BsTooltip>}
                                >
                                  <a
                                    href={url}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="d-inline-flex align-items-center text-decoration-none"
                                  >
                                    <img
                                      src={url}
                                      alt=""
                                      width={28}
                                      height={28}
                                      className="rounded border"
                                    />
                                    <span
                                      className="ms-2 text-truncate"
                                      style={{ maxWidth: 100 }}
                                    >
                                      Open
                                    </span>
                                  </a>
                                </OverlayTrigger>
                              ) : (
                                <OverlayTrigger
                                  overlay={<BsTooltip>Open file</BsTooltip>}
                                >
                                  <a
                                    href={url}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-decoration-none"
                                  >
                                    {kind === "pdf" ? "Open PDF" : "Open File"}
                                  </a>
                                </OverlayTrigger>
                              )}
                            </div>
                          );
                        })()}
                      </td> 
                        <td style={{ minWidth: 180 }}>
                          {(() => {
                            const files = getSleeveFilePaths(s);
                            if (!files.length)
                              return <span className="text-muted">—</span>;

                            const first = files[0];
                            const url = buildFileUrl(first);
                            const kind = kindFromPath(url);
                            const moreCount = Math.max(0, files.length - 1);

                            const opener =
                              kind === "image" ? (
                                <a
                                  href={url}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="d-inline-flex align-items-center text-decoration-none"
                                  title="Open file"
                                >
                                  <img
                                    src={url}
                                    alt=""
                                    width={28}
                                    height={28}
                                    className="rounded border"
                                  />
                                  <span
                                    className="ms-2 text-truncate"
                                    style={{ maxWidth: 100 }}
                                  >
                                    Open
                                  </span>
                                </a>
                              ) : (
                                <a
                                  href={url}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="text-decoration-none"
                                  title="Open file"
                                >
                                  {kind === "pdf" ? "Open PDF" : "Open File"}
                                </a>
                              );

                            return (
                              <div className="d-flex align-items-center gap-2">
                                {opener}

                                {moreCount > 0 && (
                                  <OverlayTrigger
                                    trigger="click"
                                    rootClose
                                    placement="left"
                                    overlay={
                                      <div
                                        className="popover show"
                                        role="tooltip"
                                      >
                                        <div className="popover-header">
                                          All Files
                                        </div>
                                        <div className="popover-body p-0">
                                          <Table
                                            bordered
                                            responsive
                                            size="sm"
                                            className="mb-0"
                                          >
                                            <thead>
                                              <tr>
                                                <th>#</th>
                                                <th>Type</th>
                                                <th>Open</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {files.map((fp, idx) => {
                                                const furl = buildFileUrl(fp);
                                                const fkind =
                                                  kindFromPath(furl);
                                                return (
                                                  <tr key={fp + idx}>
                                                    <td>{idx + 1}</td>
                                                    <td className="text-uppercase">
                                                      {fkind}
                                                    </td>
                                                    <td>
                                                      <a
                                                        href={furl}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="text-decoration-none"
                                                      >
                                                        {fkind === "image"
                                                          ? "Open Image"
                                                          : fkind === "pdf"
                                                          ? "Open PDF"
                                                          : "Open File"}
                                                      </a>
                                                    </td>
                                                  </tr>
                                                );
                                              })}
                                            </tbody>
                                          </Table>
                                        </div>
                                      </div>
                                    }
                                  >
                                    <Button size="sm" variant="outline-primary">
                                      +{moreCount} more
                                    </Button>
                                  </OverlayTrigger>
                                )}
                              </div>
                            );
                          })()}
                        </td>

                        <td style={{ minWidth: 220 }}>
                          {(() => {
                            const vmap =
                              s.variables ||
                              s.variable_map ||
                              s.variable_positions ||
                              s.coords ||
                              null;

                            if (!vmap || Object.keys(vmap).length === 0) {
                              return <span className="text-muted">—</span>;
                            }

                            const entries = toEntries(vmap);
                            // compact inline summary: first 2 items + count
                            const summary = entries
                              .slice(0, 2)
                              .map((e) => summarizeVar(e.key, e.val))
                              .join(" • ");
                            const moreCount = Math.max(0, entries.length - 2);

                            return (
                              <div className="d-flex align-items-center gap-2">
                                <div
                                  className="small text-truncate"
                                  title={summary}
                                  style={{ maxWidth: 260 }}
                                >
                                  {summary}
                                  {moreCount ? ` • +${moreCount} more` : ""}
                                </div>

                                <OverlayTrigger
                                  trigger="click"
                                  rootClose
                                  placement="left"
                                  overlay={
                                    <div
                                      className="popover show"
                                      role="tooltip"
                                    >
                                      <div className="popover-header">
                                        Variables
                                      </div>
                                      <div className="popover-body p-0">
                                        <Table
                                          bordered
                                          responsive
                                          size="sm"
                                          className="mb-0"
                                        >
                                          <thead>
                                            <tr>
                                              <th
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                Key
                                              </th>
                                              <th>X</th>
                                              <th>Y</th>
                                              <th>W</th>
                                              <th>H</th>
                                              <th>Font</th>
                                              <th>Style</th>
                                              <th>Rotate</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {entries.map(({ key, val }) => {
                                              const x = has(val, "x")
                                                ? fmt(val.x)
                                                : "—";
                                              const y = has(val, "y")
                                                ? fmt(val.y)
                                                : "—";
                                              const w = has(val, "width")
                                                ? fmt(val.width)
                                                : "—";
                                              const h = has(val, "height")
                                                ? fmt(val.height)
                                                : "—";
                                              const font = has(val, "font_size")
                                                ? fmt(
                                                    val.font_size ??
                                                      val.fontSize
                                                  )
                                                : "—";
                                              const style =
                                                val?.font_style ??
                                                val?.fontStyle ??
                                                "—";
                                              const rot =
                                                has(val, "rotate") ||
                                                has(val, "rotation") ||
                                                has(val, "font_type")
                                                  ? fmt(
                                                      val.font_type ??
                                                        val.rotate ??
                                                        val.rotation
                                                    )
                                                  : "—";

                                              return (
                                                <tr key={key}>
                                                  <td className="text-nowrap">
                                                    {key}
                                                  </td>
                                                  <td>{x}</td>
                                                  <td>{y}</td>
                                                  <td>{w}</td>
                                                  <td>{h}</td>
                                                  <td>{font}</td>
                                                  <td className="text-capitalize">
                                                    {style}
                                                  </td>
                                                  <td>
                                                    {rot === "—"
                                                      ? "—"
                                                      : `${rot}°`}
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </Table>
                                      </div>
                                    </div>
                                  }
                                >
                                  <Button size="sm" variant="outline-primary">
                                    View
                                  </Button>
                                </OverlayTrigger>
                              </div>
                            );
                          })()}
                        </td>

                        
                        <td>
                          
                        
                          <Button
                            size="sm"
                            className="table-btn me-2"
                            onClick={() => startEdit(s)}
                            title="Edit"
                          >
                            <MdEdit />
                          </Button>
                          
                          
                          <Button
                            size="sm"
                            className="table-btn"
                            onClick={() => {
                              setSleeveToDelete(s);
                              setShowDeleteModal(true);
                            }}
                            title="Delete"
                          >
                            <MdDelete />
                          </Button>
                          
                        </td>
                      </tr>
                    ))}
                    {sleeves.length === 0 && !loading && (
                      <tr>
                        <td colSpan={8} className="text-center text-muted">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </>
            )}
          </div> */}

          <SimpleTable
            loading={loading}
            data={sleeves}
            columns={columns}
            responsive={true}
            keyField="id"
            emptyMessage="No records found"
            onEdit={(s) => startEdit(s)}
            onDelete={(s) => {
              setSleeveToDelete(s);
              setShowDeleteModal(true);
            }}
          />

          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            loading={loading}
            onPageChange={setCurrentPage}
            className={"sticky-bottom"}
            pageSize={pageSize}
            setPageSize={setPageSize}
            setCurrentPage={setCurrentPage}
            total={total}
            perPageOptions={DEFAULT_PAGE_OPTIONS}
          />
        </div>
      </div>

      {/* delete modal */}
      <DeleteModal
        confirmDelete={removeSleeve}
        show={showDeleteModal}
        title={"Delete Sleeve"}
        onHide={() => setShowDeleteModal(false)}
        onCancel={() => setShowDeleteModal(false)}
        message={`Are you sure you want to delete <strong>${sleeveToDelete?.sleeve_name}</strong>?`}
      />

      {/* import modal */}
      <ImportModal
        show={showImport}
        onHide={() => {
          if (importing) return;
          setImportReport(null);
          setImportSuccess(null);
          setShowImport(false);
        }}
        onExit={() => {
          setImportReport(null);
          setImportSuccess(null);
          setShowImport(false);
        }}
        onImport={onImport}
        downloadValidationErrorsCsv={downloadValidationErrorsCsv}
        importSuccess={importSuccess}
        importReport={importReport}
        importing={importing}
        loading={loading}
      />

      {/* edit modal */}
      {/* Add / Edit Sleeve Modal */}
      <SleeveModal
        show={showModal}
        onHide={handleCloseSleeveModal}
        isEdit={editing}
        form={form}
        setForm={setForm}
        saveSleeve={saveSleeve}
        varCoords={varCoords}
        setVarCoords={setVarCoords}
        varSizes={varSizes}
        setVarSizes={setVarSizes}
        errors={errors}
        setErrors={setErrors}
      />
      {/* image preview modal */}
      <ImageModal
        show={imageModal?.open}
        onHide={() => {
          setImageModal({ open: false, image: "", alt: "" });
        }}
        image={imageModal?.image}
        alt={imageModal?.alt}
      />

      {/* <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{editing ? "Edit Sleeve" : "Add Sleeve"}</Modal.Title>
        </Modal.Header>

        <Form onSubmit={saveSleeve}>
          <Modal.Body>
            <Row className="g-3">
              
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Sleeve Type*</Form.Label>
                  <Form.Control
                    value={form.sleeve_type}
                    onChange={(e) =>
                      setForm({ ...form, sleeve_type: e.target.value })
                    }
                    required
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Sleeve Name*</Form.Label>
                  <Form.Control
                    value={form.sleeve_name}
                    onChange={(e) =>
                      setForm({ ...form, sleeve_name: e.target.value })
                    }
                    required
                  />
                </Form.Group>
              </Col>

              
              {!editing && (
                <>
                  
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Sleeve Width</Form.Label>
                      <Form.Control
                        type="number"
                        value={form.sleeve_width}
                        onChange={(e) =>
                          setForm({ ...form, sleeve_width: e.target.value })
                        }
                      />
                    </Form.Group>
                  </Col>

                  
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Sleeve Height</Form.Label>
                      <Form.Control
                        type="number"
                        value={form.sleeve_height}
                        onChange={(e) =>
                          setForm({ ...form, sleeve_height: e.target.value })
                        }
                      />
                    </Form.Group>
                  </Col>

                  
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Print Page Width</Form.Label>
                      <Form.Control
                        type="number"
                        value={form.print_page_width}
                        onChange={(e) =>
                          setForm({ ...form, print_page_width: e.target.value })
                        }
                      />
                    </Form.Group>
                  </Col>

                  
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Print Page Height</Form.Label>
                      <Form.Control
                        type="number"
                        value={form.print_page_height}
                        onChange={(e) =>
                          setForm({
                            ...form,
                            print_page_height: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>

                  
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Orientation</Form.Label>
                      <Form.Select
                        value={form.orientation}
                        onChange={(e) =>
                          setForm({ ...form, orientation: e.target.value })
                        }
                      >
                        <option value="">Select Orientation</option>
                        <option value="Portrait">Portrait</option>
                        <option value="Landscape">Landscape</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Print Type</Form.Label>
                      <Form.Select
                        value={form.print_type}
                        onChange={(e) =>
                          setForm({ ...form, print_type: e.target.value })
                        }
                      >
                        <option value="">Select Print Type</option>
                        <option value="One Side">One Side</option>
                        <option value="Front back">Front back</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Qty in Page</Form.Label>
                      <Form.Control
                        type="number"
                        value={form.qty_in_page}
                        onChange={(e) =>
                          setForm({ ...form, qty_in_page: e.target.value })
                        }
                      />
                    </Form.Group>
                  </Col>

                  
                  <div className="mt-4 mb-4 px-3">
                    <h5 className="mb-3">Variable Coordinates</h5>

                    <Table bordered responsive size="sm" className="mb-0">
                      <thead>
                        <tr>
                          <th style={{ width: 220 }}>Name</th>
                          <th style={{ width: 120 }}>X</th>
                          <th style={{ width: 120 }}>Y</th>
                          <th style={{ width: 140 }}>Font Size</th>
                          <th style={{ width: 160 }}>Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          {
                            key: "client_name",
                            label: "Client Name",
                            hasFont: true,
                            hasType: true,
                          },
                          {
                            key: "order_id",
                            label: "Order ID",
                            hasFont: true,
                            hasType: true,
                          },
                          {
                            key: "date",
                            label: "Date",
                            hasFont: true,
                            hasType: true,
                          },
                          
                          {
                            key: "partner_box",
                            label: "Partner Box (Position)",
                            hasFont: false,
                            hasType: false,
                          },
                        ].map((row) => (
                          <tr key={row.key}>
                            <td className="text-nowrap align-middle">
                              {row.label}
                            </td>
                            <td>
                              <Form.Control
                                type="number"
                                step="any"
                                value={varCoords[row.key]?.x ?? ""}
                                onChange={(e) =>
                                  handleCoordChange(
                                    row.key,
                                    "x",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="number"
                                step="any"
                                value={varCoords[row.key]?.y ?? ""}
                                onChange={(e) =>
                                  handleCoordChange(
                                    row.key,
                                    "y",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="number"
                                step="any"
                                value={
                                  row.hasFont
                                    ? varCoords[row.key]?.font_size ?? ""
                                    : ""
                                }
                                onChange={(e) =>
                                  handleCoordChange(
                                    row.key,
                                    "font_size",
                                    e.target.value
                                  )
                                }
                                disabled={!row.hasFont}
                              />
                            </td>
                            <td>
                              {row.hasType ? (
                                <Form.Select
                                  value={varCoords[row.key]?.type ?? "text"}
                                  onChange={(e) =>
                                    handleCoordChange(
                                      row.key,
                                      "type",
                                      e.target.value
                                    )
                                  }
                                >
                                  <option value="text">Text</option>
                                  <option value="dropdown">Dropdown</option>
                                  <option value="number">Number</option>
                                </Form.Select>
                              ) : (
                                <Form.Control value="" disabled />
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>

                  
                  <div className="mt-4 mb-4 px-3">
                    <h5 className="mb-3">Variable Sizes</h5>

                    <Table bordered responsive size="sm" className="mb-0">
                      <thead>
                        <tr>
                          <th style={{ width: 220 }}>Name</th>
                          <th style={{ width: 140 }}>Width</th>
                          <th style={{ width: 140 }}>Height</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          { key: "logo_size", label: "Logo Size" },
                          {
                            key: "partner_box",
                            label: "Partner Box",
                          },
                        ].map((row) => (
                          <tr key={row.key}>
                            <td className="text-nowrap align-middle">
                              {row.label}
                            </td>
                            <td>
                              <Form.Control
                                type="number"
                                step="any"
                                value={varSizes[row.key]?.width ?? ""}
                                onChange={(e) =>
                                  handleSizeChange(
                                    row.key,
                                    "width",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="number"
                                step="any"
                                value={varSizes[row.key]?.height ?? ""}
                                onChange={(e) =>
                                  handleSizeChange(
                                    row.key,
                                    "height",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </>
              )}
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              {editing ? "Update" : "Create"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal> */}

      {/* <Modal
        show={showImport}
        onHide={() => setShowImport(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Import Partners from Excel</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Select .xlsx/.xls file</Form.Label>
            <Form.Control type="file" accept=".xlsx,.xls" onChange={onImport} />
          </Form.Group>
          <div className="text-muted small">
            The import upserts by partner_code or email.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowImport(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal> */}

      {/* <Modal
        show={showImport}
        onHide={() => {
          if (importing) return;
          setImportReport(null);
          setImportSuccess(null);
          setShowImport(false);
        }}
        size={importSuccess && importReport ? "xl" : "md"}
        centered
        backdrop={importing ? "static" : true} // don't allow closing
        keyboard={!importing}
      >
        <Modal.Header closeButton={!importing}>
          <Modal.Title>Import Sleeves from Excel</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {importing ? (
            // 🔄 Loading view
            <div className="text-center my-4">
              <Spinner animation="border" role="status" />
              <div className="mt-2">Importing… please wait</div>
            </div>
          ) : (
            <>
              {importSuccess === null && (
                <Form.Group className="mb-3">
                  <Form.Label>Select .xlsx/.xls file</Form.Label>
                  <Form.Control
                    type="file"
                    accept=".xlsx,.xls"
                    onChange={onImport}
                  />
                  <div className="text-muted small">
                    Ensure the file matches the required headers. The import
                    will upsert using a unique key (e.g., sleeve_code or
                    name—depending on your backend).
                  </div>
                </Form.Group>
              )}

              {importSuccess === true && importReport && (
                <div className="d-grid columns-2 columns-md-4 gap-3">
                  <div className=" p-2 border rounded text-center bg-light">
                    <strong>Total:</strong> {importReport?.totalRows ?? 0}
                  </div>

                  <div className=" p-2 border rounded text-center bg-light">
                    <strong>Created:</strong> {importReport?.createdCount ?? 0}
                  </div>

                  <div className=" p-2 border rounded text-center bg-light">
                    <strong>Updated:</strong> {importReport?.updatedCount ?? 0}
                  </div>

                  <div className=" p-2 border rounded text-center bg-light">
                    <strong>Errors:</strong> {importReport?.errorCount ?? 0}
                  </div>
                </div>
              )}

              {importSuccess === false && importReport && (
                <>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="mb-0">
                      {(importReport?.createdCount ?? 0) +
                        (importReport?.updatedCount ?? 0) >
                      0
                        ? "Imported with errors"
                        : "Validation Errors"}
                    </h6>
                    {importReport?.errors?.length > 0 && (
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={() =>
                          downloadValidationErrorsCsv(importReport)
                        }
                      >
                        Download errors (.csv)
                      </Button>
                    )}
                  </div>

                  <Table bordered responsive size="sm">
                    <thead>
                      <tr>
                        <th>Sr.</th>
                        <th>Row</th>
                        <th>Errors</th>
                        <th>Data (original)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {importReport?.errors?.map((error, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{error.row}</td>
                          <td>
                            <ul className="mb-0 ps-3">
                              {error.errors?.map((msg, idx) => (
                                <li key={idx}>{msg}</li>
                              ))}
                            </ul>
                          </td>
                          <td>
                            <code className="small">
                              {JSON.stringify(error.data, null, 0)}
                            </code>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          {importing ? (
            <Button variant="secondary" disabled>
              <Spinner animation="border" size="sm" className="me-2" />
              Importing…
            </Button>
          ) : importSuccess === null ? (
            <Button
              variant="secondary"
              onClick={() => {
                setImportReport(null);
                setImportSuccess(null);
                setShowImport(false);
              }}
            >
              Close
            </Button>
          ) : (
            <Button
              variant="outline-secondary"
              onClick={() => {
                setImportReport(null);
                setImportSuccess(null);
                setShowImport(false);
              }}
            >
              Done
            </Button>
          )}
        </Modal.Footer>
      </Modal> */}
    </>
  );
};

export default Sleeves;
